// @TODO <HEALTH2019>
App.controller('ZochReportHealthListCtrl', ['$scope', '$sce', '$state', '$http', 'Config', '$mdDialog', 'zochaReportService', '$timeout', '$stateParams', 'Blob', 'FileSaver', 'profileService', '$rootScope', 'popUpService', 'branchService', '$filter', '$interval', function ($scope, $sce, $state, $http, Config, $mdDialog, zochaReportService, $timeout, $stateParams, Blob, FileSaver, profileService, $rootScope, popUpService, branchService, $filter, $interval) {
// @TODO </HEALTH2019>
    $scope.stateParams = $stateParams;

    $scope.page = 'zoch_report';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Lista raportów';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.dashboard';
    $scope.$emit('link', $scope.link);

    var page = 0;
    let generateTimeout;
    let generateReportInterval;
    $scope.current = page;
    $scope.pageSize = 10;

    $scope.isSelectForTypeReportEnabled = $rootScope.CONFIGURATOR.zoch.healthInsurance.isSelectForTypeReportEnabled;
    $scope.isConfigWhereReportForAllBranches = $rootScope.CONFIGURATOR.zoch.healthInsurance.reportForAllBranches;

    var userObject = angular.fromJson(window.sessionStorage.getItem('userObject'));
    $scope.userBranch = userObject.branch;
    $rootScope.declarationStatus = 'ALL';

    loadReports(page);
    loadBranch();

    function loadBranch() {
        $rootScope.selectedBranchDeduction = null;
        $scope.branches = [];
        branchService.getZochaAllowedBranchesForReports().then(function (data) {
            $scope.branches = data.data.data;
            $rootScope.selectedBranchDeduction = $scope.branches[0];
        });
    }

    function createFilterForItem(query) {
        var lowercaseQuery = angular.lowercase(query);

        return function filterFn(items) {
            return (angular.lowercase(items.name).indexOf(lowercaseQuery) !== -1);
        };
    }

    function loadReports(page) {
        var criteria = {
            pageNumber: page,
            pageSize: $scope.pageSize
        };

        zochaReportService.dataHealthDeductionReportList(criteria).then(function (data) {
            if (data.status === 200) {
                $scope.reports = data.data.data;
                $scope.numberOfPages = data.data.pages;

                if ($scope.isSelectForTypeReportEnabled) {
                    zochaReportService.dataHealthDeductionChangesReportList(criteria).then(function (dataChanges) {
                        if (dataChanges.status === 200) {
                            angular.forEach(dataChanges.data.data, function (item) {
                                $scope.reports.push(item);
                            });
                            $scope.reports = $filter('orderBy')($scope.reports, 'creationTime', true);
                        }
                    });
                }
            }
        });
    }

    $scope.getDeclarationStatusName = function (status) {
        switch (status) {
            case 'ALL':
                return 'Lista ogólna';
            case 'NEW':
                return 'Przystąpienia';
            case 'CHANGES':
                return 'Zmiany';
            default:
                return 'Zmiany';
        }
    };

    $scope.querySearchBranch = function (query) {
        return query ? $scope.branches.filter(createFilterForItem(query)) : $scope.branches;
    };

    $scope.pageChanged = function (page) {
        loadReports(page);
        $scope.current = page;

    };

    $scope.getReport = function (ev, value) {
        var id = value.id;

        var el = $(ev.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(ev.currentTarget).addClass('disabled');
        }

        var action;
        if (!value.declarationStatus) {
            action = zochaReportService.getHealthDeductionChangesReport({id: id, method: 'excel'});
        } else {
            action = zochaReportService.getHealthDeductionReport({id: id, method: 'excel'});
        }

        action.then(function (data) {
            if (data.status === 200) {
                var blob = new Blob([data.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});

                FileSaver.saveAs(blob, zochaReportService.prepareReportName(value, 'healthInsurance'));
            }

            $timeout(function () {
                $(ev.currentTarget).removeClass('disabled');
            }, 1500);
        });

    };

    $scope.generate = function (ev) {
        var el = $(ev.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(ev.currentTarget).addClass('disabled');
        }
        var branch = $scope.userBranch;

        if (!$scope.isConfigWhereReportForAllBranches || !branch) {
            branch = $rootScope.selectedBranchDeduction;
        }
        if (!branch && !$scope.isSelectForTypeReportEnabled) {
            popUpService.showPopUp({head: 'Brak oddziału', content: 'Nie posiadasz przypisanego oddziału'});
            return;
        }

        var company = branch.company;
        var branchId = branch.id;
        if ($scope.isConfigWhereReportForAllBranches) {
            branch = null;
        }

        var _moment = moment();

        var month = parseInt(_moment.format('M'));
        var year = parseInt(_moment.format("YYYY"));

        generateTimeout && $timeout.cancel(generateTimeout);

        var actionObject = {
            declarationStatus: $rootScope.declarationStatus,
            branch: branch,
            company: company,
            month: month,
            year: year
        };

        if (!$scope.isConfigWhereReportForAllBranches && $rootScope.declarationStatus === 'CHANGES') {
            actionObject['branchId'] = branchId;
        }

        var action = $rootScope.declarationStatus === 'CHANGES' ?
            zochaReportService.generateHealthDeductionChangesReport(actionObject) :
            zochaReportService.generateHealthDeductionReport(actionObject);


        action.then(function (data) {
            if (data.status === 200) {
                $state.reload();
            }

            generateTimeout = $timeout(function () {
                $(ev.currentTarget).removeClass('disabled');
                $state.reload();
            }, 3000);
        });
    };

    function expandMenuAfterReload() {
        var target = $('ul.menu.menu_5');
        if (!target) {
            return;
        }
        var h = target[0].scrollHeight;

        $(target).addClass('open');
        $('.sidebar').addClass('opened');
        $(target).velocity("stop", true).velocity({height: h});
    }

    $timeout(function () {
        expandMenuAfterReload();
    }, 500);

    generateReportInterval = $interval(function () {
        loadReports(page);
    }, 5000);

    $scope.$on('$destroy', function () {
        if (angular.isDefined(generateTimeout)) {
            $timeout.cancel(generateTimeout);
            generateTimeout = undefined;
        }
        if (angular.isDefined(generateReportInterval)) {
            $interval.cancel(generateReportInterval);
            generateReportInterval = undefined;
        }
    });
}]);
